import { render, staticRenderFns } from "./MultipleChoiceQuestionComponent.vue?vue&type=template&id=0abeb81d&scoped=true&"
import script from "./MultipleChoiceQuestionComponent.vue?vue&type=script&lang=js&"
export * from "./MultipleChoiceQuestionComponent.vue?vue&type=script&lang=js&"
import style0 from "./MultipleChoiceQuestionComponent.vue?vue&type=style&index=0&id=0abeb81d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abeb81d",
  null
  
)

export default component.exports